import React from 'react';
import FloatingInfo from './FloatingInfo';
import FloatingBadge from './FloatingBadge';

export default function GlobalFloating() {
  return (
    <>
      <FloatingInfo label="Service Oficial" />
      <FloatingBadge label="Service Oficial" />
    </>
  );
}
